import { memo } from 'react'
import { useSelector } from 'react-redux'

import { firstPremiumPaidAdSelector } from '../stores/paidAds/selectors'

import FPPAP from './FPPAP'

const FeaturedAdHandler = () => {
  const data = useSelector(firstPremiumPaidAdSelector)

  if (!data || !data.id) {
    return null
  }

  return <FPPAP campaignId={data.id} />
}

export default memo(FeaturedAdHandler)
